/**
 * Копирует переданный текст в буфер обмена.
 *
 * @param text Текст, который должен быть скопирован
 * @returns Промис, который будет зарезолвлен после успешного копирования
 *
 * @example
 * ```typescript
 * import { copyTextToClipboard } from '@direct-frontend/stdlib';
 *
 * try {
 *     await copyTextToClipboard('Hello, world!');
 *     emitSuccessToast('Текст скопирован!');
 * } catch (error) {
 *     emitErrorToast('Не удалось скопировать текст :(');
 * }
 * ```
 */
export function copyTextToClipboard(text) {
    return new Promise((resolve, reject) => {
        const range = document.createRange();
        let mark;
        try {
            mark = document.createElement('span');
            mark.textContent = text;
            // reset user styles for span element
            mark.style.all = 'unset';
            // prevents scrolling to the end of the page
            mark.style.position = 'fixed';
            mark.style.top = '0';
            mark.style.clip = 'rect(0, 0, 0, 0)';
            // used to preserve spaces and line breaks
            mark.style.whiteSpace = 'pre';
            // do not inherit user-select (it may be `none`)
            mark.style.webkitUserSelect = 'text';
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- автоматический игнор в рамках DIRECT-265451. Исправьте при следующем редактировании при помощи type-assert, чтобы избежать возможных ложно-положительных проверок typecheck!
            // @ts-expect-error Неизвестный тайпскрипту префикс для IE
            mark.style.MozUserSelect = 'text';
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- автоматический игнор в рамках DIRECT-265451. Исправьте при следующем редактировании при помощи type-assert, чтобы избежать возможных ложно-положительных проверок typecheck!
            // @ts-expect-error Неизвестный тайпскрипту префикс для IE
            mark.style.msUserSelect = 'text';
            mark.style.userSelect = 'text';
            document.body.appendChild(mark);
            range.selectNodeContents(mark);
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand('copy');
            }
            resolve();
        }
        catch (error) {
            reject();
        }
        if (mark) {
            document.body.removeChild(mark);
        }
    });
}
